// Ref: https://github.com/vuejs-tips/vue-the-mask/blob/master/src/directive.js
import { getInputElement, event, insertAfter, createMaskElement, generateClassName } from './common'
import Cleave from 'cleave.js'
import Vue from 'vue'

/**
 * Takes in param:
 * negative: false (default)
 * intScale: 10 (default)
 * decScale: 2 (default)
 */

function bind(el, binding, vnode) {
  // In Binding, we will create the dummy mask input element and attach it to the document
  const maskClass = generateClassName()
  const maskInput = createMaskElement(maskClass)
  insertAfter(maskInput, el)
  el.maskClass = maskClass
}

function inserted(el, binding) {
  Vue.nextTick(() => {
    // Cleave cannot initiate on bind as I think the mask element has not registered in the document
    // So we will do it here
    if (el.maskClass) {
      let negative = false
      let intScale = 10
      let decScale = 2
      if (binding.value !== undefined && binding.value !== null) {
        if (binding.value.negative) {
          negative = binding.value.negative
        }
        if (binding.value.intScale) {
          intScale = binding.value.intScale
        }
        if (binding.value.decScale) {
          decScale = binding.value.decScale
        }
      }
      try {
        const cleave = new Cleave('.' + el.maskClass, {
          numeral: true,
          numeralDecimalMark: '.',
          delimiter: ',',
          numeralIntegerScale: intScale,
          numeralDecimalScale: decScale,
          numeralPositiveOnly: !negative
        })
        el.cleave = cleave

        const maskInputArr = document.getElementsByClassName(el.maskClass)
        if (maskInputArr && maskInputArr.length > 0) {
          // const maskInput = maskInputArr[0]
          const inputEL = getInputElement(el)
          inputEL.oninput = function (evt) {
            if (!evt.isTrusted) return // avoid infinite loop

            // The position tracking code doesnt work well with num masking
            // as the delimiter is added infront instead of behind and this will mess up the position tracking
            // If really need, might need some work ard here
            cleave.setRawValue(inputEL.value)
            inputEL.value = cleave.properties.result

            inputEL.dispatchEvent(event('input'))
          }
          // Mask the initial value also
          if (inputEL.value !== undefined && inputEL.value !== null) {
            cleave.setRawValue(inputEL.value)
            if (inputEL.value !== cleave.properties.result) {
              inputEL.value = cleave.properties.result
              inputEL.dispatchEvent(event('input'))
            }
          }
          inputEL.onblur = function (evt) {
            if (!evt.isTrusted) return
            // Constant decimal format check
            let args = (inputEL.value || '').split('.')
            let decimal
            if (args.length > 1) {
              const decLength = args[1].length
              if (decLength < decScale) {
                decimal = String.prototype.padEnd((decScale - decLength), '0')
                args[1] = args[1] + decimal
              }
            } else {
              if (args[0] === undefined || args[0] === '') {
                args[0] = '0'
              }
              decimal = String.prototype.padEnd(decScale, '0')
              args.push(decimal)
            }
            inputEL.value = args.join('.')
            inputEL.dispatchEvent(event('input'))
          }
        } else {
          throw new Error('Cannot find mask input')
        }
      } catch (err) {
        //
      }
    }
  })
}

function unbind(el, binding) {
  if (el.cleave) {
    try {
      el.cleave.destroy()
    } catch (err) {
      //
    }
  }
}

export default {
  name: 'numMask',
  bind,
  inserted,
  unbind
}
